import React, { useState, useEffect , useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import {useReactToPrint} from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 



function CompanyMaster(props) {
  const [rooms, setRooms] = useState([]);
  const [CompCode, setCompCode] = useState('');
  const [CompName, setCompName] = useState('');
  const [CompAddress, setCompAddress] = useState('');
  const [CompAddress1, setCompAddress1] = useState('');
  const [CompAddress2, setCompAddress2] = useState('');
  const [CompCity, setCompCity] = useState('');
  const [CompStateCode, setCompStateCode] = useState('');
  const [CompGSTIN, setCompGSTIN] = useState('');
  const [CompPhone, setCompPhone] = useState('');
  const [CompEmail, setCompEmail] = useState('');
  const [Fax, setFax] = useState('');
  const [WebSite, setWebsite] = useState('');
  const [CompNarr1, setCompNarr1] = useState('');
  const [CompNarr2, setCompNarr2] = useState('');

  const [compMasterEntries, setCompMasterEntries] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  const [flag, setFlag] = useState('');
  const [formMode, setFormMode] = useState('add');
  const [editRoomId, setEditRoomId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);  

  
  useEffect(() => {
    fetchCompMaster();
  }, []);


  const fetchCompMaster = async () =>{
    try{
      const response = await axios.get('https://www.wingap.net.in/api/company');
      setCompMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setCompCode(nextEntryNo)
      //console.log(response)
    }catch(error){
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.CompCode > maxEntryNo) {
        maxEntryNo = entry.CompCode;
      }
    }
    return maxEntryNo;
  };



  const addMaster = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/company', {
        CompCode: CompCode,
        CompName: CompName,
        CompAddress: CompAddress,
        CompAddress1: CompAddress1,
        CompAddress2: CompAddress2,
        CompCity: CompCity,
        CompStateCode: CompStateCode,
        CompGSTIN: CompGSTIN,
        CompPhone: CompPhone,
        CompEmail:CompEmail,
        Fax: Fax,
        WebSite: WebSite,
        CompNarr1: CompNarr1,
        CompNarr2: CompNarr2,
        USERID: props.name
      });
      fetchCompMaster();
      setCompCode('');
      setCompName('');
      setCompAddress('');
      setCompAddress1('');
      setCompAddress2('');
      setCompCity('');
      setCompStateCode('');
      setCompGSTIN('');
      setCompPhone('');
      setCompEmail('');
      setFax('');
      setWebsite('');
      setCompNarr1('');
      setCompNarr2('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateRoom = async (CompCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/company/${CompCode}`, {
        CompCode: CompCode,
        CompName: CompName,
        CompAddress: CompAddress,
        CompAddress1: CompAddress1,
        CompAddress2: CompAddress2,
        CompCity: CompCity,
        CompStateCode: CompStateCode,
        CompGSTIN: CompGSTIN,
        CompPhone: CompPhone,
        CompEmail:CompEmail,
        Fax: Fax,
        WebSite: WebSite,
        CompNarr1: CompNarr1,
        CompNarr2: CompNarr2,
        USERID: props.name
      });
      fetchCompMaster();
      setCompCode('');
      setCompName('');
      setCompAddress('');
      setCompAddress1('');
      setCompAddress2('');
      setCompCity('');
      setCompStateCode('');
      setCompGSTIN('');
      setCompPhone('');
      setCompEmail('');
      setFax('');
      setWebsite('');
      setCompNarr1('');
      setCompNarr2('');
      setFormMode('add');
    
    } catch (error) {
      console.log('Error:', error);
    }
  };
  
  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteRoom(deleteEntryNo.CompCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteRoom = async (CompCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/company/${CompCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        await fetchCompMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  }; 

  const setEditForm = (room) => {
    setFormMode('edit');
    setCompCode(room.CompCode);
      setCompName(room.CompName);
      setCompAddress(room.CompAddress);
      setCompAddress1(room.CompAddress1);
      setCompAddress2(room.CompAddress2);
      setCompCity(room.CompCity);
      setCompStateCode(room.CompStateCode);
      setCompGSTIN(room.CompGSTIN);
      setCompPhone(room.CompPhone);
      setCompEmail(room.CompEmail);
      setFax(room.Fax);
      setWebsite(room.WebSite);
      setCompNarr1(room.CompNarr1);
      setCompNarr2(room.CompNarr2);
      setShowGrid(false);
  };

 
  /* const handleSearch = (searchQuery) => {
    const filtered = rooms.filter((room) => {
      // Convert room.RoomNo, room.deptName, etc., to strings before using includes
      const deptCode = room.DeptCode.toString().toLowerCase();
      const deptName = room.deptName.toString().toLowerCase();
      const deptNameENG = room.deptNameENG.toString().toLowerCase();
      const compCode = room.compCode.toString().toLowerCase();
      const flag = room.flag.toString().toLowerCase();

      // Check if any of the properties contain the searchQuery (converted to lowercase)
      return (
        deptCode.includes(searchQuery.toLowerCase()) ||
        deptName.includes(searchQuery.toLowerCase()) ||
        deptNameENG.includes(searchQuery.toLowerCase()) ||
        compCode.includes(searchQuery.toLowerCase()) ||
        flag.includes(searchQuery.toLowerCase())
      );
    }); 

    // Update the deptMasterEntries state with the filtered results
    setDeptMasterEntries(filtered);
  };*/

  // ... Rest of your code ...

  // Update the filtered rooms based on the searchQuery prop
  /* useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, rooms]);
 */
  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setRooms(rooms); 
  }

  const handleCancel = () => {
    setFormMode('add');
    setEditRoomId('');
    setCompCode('');
      setCompName('');
      setCompAddress('');
      setCompAddress1('');
      setCompAddress2('');
      setCompCity('');
      setCompStateCode('');
      setCompGSTIN('');
      setCompPhone('');
      setCompEmail('');
      setFax('');
      setWebsite('');
      setCompNarr1('');
      setCompNarr2('');
  }

   
  const componentPDF= useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "CompanyData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto',padding: '20px' }} >
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Company Master</h1>
      <Grid item>
          <Button
            variant="contained"
            className="view-button"
            onClick={handleshowandhide}
            sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float:'right'}}
          >
            {showGrid ? 'Add' : 'Back'}
          </Button>
        </Grid>
        {showGrid && <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Download PDF
          </Button>
        </Grid>}
        {showGrid && <Grid item>
          <Button
            variant="contained"
            // onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Export
          </Button>
        </Grid>}
        {!showGrid && (
           <>
           <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
           <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompCode" style={{ width: '150px', marginRight: '10px' }}>CompCode</label>
               <input
                 type="text"
                 value={CompCode}
                 readOnly
                 placeholder="CompCode"
                 style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompName" style={{ width: '150px', marginRight: '10px' }}>CompName</label>
               <input
                 type="text"
                 value={CompName}
                 onChange={(e) => setCompName(e.target.value)}
                 placeholder="CompName"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
                 list="deptNames"
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompAddress" style={{ width: '150px', marginRight: '10px' }}>CompAddress</label>
               <input
                 type="text"
                 value={CompAddress}
                 onChange={(e) => setCompAddress(e.target.value)}
                 placeholder="CompAddress"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompAddress1" style={{ width: '150px', marginRight: '10px' }}>CompAddress1</label>
               <input
                 type="text"
                 value={CompAddress1}
                 onChange={(e) => setCompAddress1(e.target.value)}
                 placeholder="CompAddress1"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompAddress2" style={{ width: '150px', marginRight: '10px' }}>CompAddress2</label>
               <input
                 type="text"
                 value={CompAddress2}
                 onChange={(e) => setCompAddress2(e.target.value)}
                 placeholder="CompAddress2"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompCity" style={{ width: '150px', marginRight: '10px' }}>CompCity</label>
               <input
                 type="text"
                 value={CompCity}
                 onChange={(e) => setCompCity(e.target.value)}
                 placeholder="CompCity"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompStateCode" style={{ width: '150px', marginRight: '10px' }}>CompStateCode</label>
               <input
                 type="text"
                 value={CompStateCode}
                 onChange={(e) => setCompStateCode(e.target.value)}
                 placeholder="CompStateCode"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompGSTIN" style={{ width: '150px', marginRight: '10px' }}>CompGSTIN</label>
               <input
                 type="text"
                 value={CompGSTIN}
                 onChange={(e) => setCompGSTIN(e.target.value)}
                 placeholder="CompGSTIN"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompPhone" style={{ width: '150px', marginRight: '10px' }}>CompPhone</label>
               <input
                 type="text"
                 value={CompPhone}
                 onChange={(e) => setCompPhone(e.target.value)}
                 placeholder="CompPhone"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompEmail" style={{ width: '150px', marginRight: '10px' }}>CompEmail</label>
               <input
                 type="text"
                 value={CompEmail}
                 onChange={(e) => setCompEmail(e.target.value)}
                 placeholder="CompEmail"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="Fax" style={{ width: '150px', marginRight: '10px' }}>Fax</label>
               <input
                 type="text"
                 value={Fax}
                 onChange={(e) => setFax(e.target.value)}
                 placeholder="fax"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="Website" style={{ width: '150px', marginRight: '10px' }}>Website</label>
               <input
                 type="text"
                 value={WebSite}
                 onChange={(e) => setWebsite(e.target.value)}
                 placeholder="Website"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompNarr1" style={{ width: '150px', marginRight: '10px' }}>CompNarr1</label>
               <input
                 type="text"
                 value={CompNarr1}
                 onChange={(e) => setCompNarr1(e.target.value)}
                 placeholder="CompNarr1"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompNarr2" style={{ width: '150px', marginRight: '10px' }}>CompNarr2</label>
               <input
                 type="text"
                 value={CompNarr2}
                 onChange={(e) => setCompNarr2(e.target.value)}
                 placeholder="CompNarr2"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             </div>
           <div>
             <button
               className={formMode === 'add' ? 'add-button' : 'update-button'}
               onClick={formMode === 'add' ? addMaster : () => updateRoom(CompCode)}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginBottom: '10px',
               }}
             >
               {formMode === 'add' ? 'Add' : 'Update'}
             </button>
             <button
               className="view-button"
               onClick={handleCancel}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: '#f44336',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginLeft: '10px',
                 marginBottom: '10px',
               }}
             >
               Cancel
             </button>
           </div>
         </>
         
          )}
        {showGrid && (
            <div ref={componentPDF} style={{width:'100%'}}>
              <h2>Entries</h2>
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  border: '1px solid #ccc',
                }}
              >
                <thead>
                  <tr style={{ background: '#f2f2f2', color:'black' }}>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      CompCode
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      CompName
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      CompCity
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      GSTIN
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {compMasterEntries.map((room) => (
                    <tr key={room.CompCode} style={{backgroundColor:'white', color:'black', textAlign:'center'}}>
                      {/* <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.ID}</td> */}
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompCode}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompName}</td>
                      {/* <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompAddress}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompAddress1}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompAddress2}</td> */}
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompCity}</td>
                      {/* <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompStateCode}</td> */}
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompGSTIN}</td>
                      {/* <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompPhone}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompEmail}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.Fax}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.Website}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompNarr1}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompNarr2}</td> */}
                      <td className="print-hide" >
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(76, 175, 80)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            marginRight: '5px',
                            marginLeft:'10px',
                          }}
                          onClick={() => setEditForm(room)}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(244, 67, 54)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setDeleteEntryNo({CompCode: room.CompCode});
                            setOpenConfirmation(true); 
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

<Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
    </div>
  );
}

export default CompanyMaster;